import {
  GET_PAGING_PROSPECTIVE_HUB,
  GET_PAGING_PROSPECTIVE_HUB_ERROR,
  GET_PAGING_PROSPECTIVE_HUB_SUCCESS,
} from './types';

export const getPagingProspectHub = filter => ({
  type: GET_PAGING_PROSPECTIVE_HUB,
  payload: filter,
});

export const getPagingProspectHubSuccess = items => ({
  type: GET_PAGING_PROSPECTIVE_HUB_SUCCESS,
  payload: items,
});

export const getPagingProspectHubError = error => ({
  type: GET_PAGING_PROSPECTIVE_HUB_ERROR,
  payload: error,
});
